import { Pipe, PipeTransform } from '@angular/core';
import { SfoUiJSONSchema7 } from '../../metadata.model';

@Pipe({ name: 'handleSchemaType' })
export class HandleSchemaTypePipe implements PipeTransform {
  transform(schema: SfoUiJSONSchema7 | null | undefined): string {
    if (!schema) return '';

    // If the schema already declares a simple type or an array of types
    if (Array.isArray(schema.type)) {
      // Example: ["string","number"] → prefer 'string' to allow ranges, ids with letters, etc.
      if (schema.type.includes('string') && schema.type.includes('number')) return 'string';
      return schema.type[0] ?? '';
    }

    if (schema._ui_widget !== undefined) {
      return schema.type || 'string'; 
    }

    if (schema.anyOf || schema.oneOf) {
      const variants = (schema.anyOf || schema.oneOf) as any[] | undefined;
      if (!variants || variants.length === 0) return schema.type || '';

      const typeSet = new Set(variants.map((t: any) => t?.type).filter(Boolean));

      if (typeSet.has('object')) return 'object';
      if (typeSet.has('array')) return 'array';
      if (typeSet.has('string')) return 'string';
      if (typeSet.has('number')) return 'number';
      if (typeSet.has('boolean')) return 'boolean';

      return schema.type || '';
    }

    return schema.type || '';
  }
}
